/**
 * Receipt format.
 */
export enum ReceiptFormat {
  Email = 'email',
  Phone = 'phone',
}
